import { BRAND_QUERY_BASE_KEY } from '@/api/brands/queries/get-brands-query'
import { GetBrandQuery } from '@/api/brands/queries/get-brand-query'
import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'

export type IDeleteBrandMutationParams = {
    organizationId: string
    brandSlug: string
}

export class DeleteBrandMutation {
    static async call(api: IApi, { organizationId, brandSlug }: IDeleteBrandMutationParams) {
        // Server returns 204 No Content; api.delete resolves to null in that case.
        await api.delete(`/organization/${organizationId}/brands/${brandSlug}`)
    }
}

export function useDeleteBrandMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation({
        mutationFn: async (params: { brandSlug: string }) => {
            if (!apiParams.organizationId) throw new Error('Workspace not found')

            await DeleteBrandMutation.call(api, {
                organizationId: apiParams.organizationId,
                brandSlug: params.brandSlug,
            })

            // Drop the deleted brand's single-brand queries so observers don't
            // briefly see a 404 before the list invalidation settles.
            qc.removeQueries({
                queryKey: GetBrandQuery.getKey(
                    { organizationId: apiParams.organizationId, brandSlug: params.brandSlug },
                    false
                ),
            })
            qc.removeQueries({
                queryKey: GetBrandQuery.getKey(
                    { organizationId: apiParams.organizationId, brandSlug: params.brandSlug },
                    true
                ),
            })
            qc.invalidateQueries({ queryKey: BRAND_QUERY_BASE_KEY })
        },
    })
}
